import { Box } from '@mui/material';
import { Sidebar } from './Sidebar';
import { AgentPanel, AgentToggleButton, ChatPanel } from '../ai';
import { useUIStore } from '../../stores/useUIStore';

export function Layout({ children }: { children: React.ReactNode }) {
  const agentPanelOpen = useUIStore((state) => state.agentPanelOpen);

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: 0,
          minWidth: 0,
          p: 0,
          bgcolor: 'background.default',
          transition: 'all 0.3s ease',
          height: '100%',
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
      {agentPanelOpen ? (
        <AgentPanel>
          <ChatPanel />
        </AgentPanel>
      ) : (
        <AgentToggleButton />
      )}
    </Box>
  );
}
